import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import { Link } from 'react-router-dom';

import Section from '../../components/Section';
import SectionHeader from '../../components/SectionHeader';
import SectionBody from '../../components/SectionBody';

import { ReactComponent as Icon } from '../../assets/icons/PC.svg';
import Image from '../../assets/icons/PC_grey.svg';

const useStyles = makeStyles(() => ({
    content: {
        fontSize: 16
    },
    topText: {
        fontFamily: 'SourceSansPro-Regular',
        marginBottom: 20
    },
    links: {
        fontFamily: 'SourceSansPro-SemiBold',
    },
    listItem: {
        marginBottom: 20,
    },
    link: {
        color: '#ed1c24'
    }
}));

const ProductCatalogue = () => {
    const classes = useStyles();

    return (
        <Section backgroundImage={Image}>
            <SectionHeader title="Product Catalogue">
                <Icon width={40}
                    height={40} />
            </SectionHeader>
            <SectionBody>
                <Grid container className={classes.content}>

                    <ul className={classes.links}>

                        <li className={classes.listItem}>
                            <a href="/docs/productcatalogue" className="linkText" underline='none' rel='noopener noreferrer'>Documentation</a>
                        </li>
                        <li className={classes.listItem}>

                            <Link
                                className="linkText"
                                to={"/releaseversion/productcatalogue"}
                                underline='none'
                                rel='noopener noreferrer'>Releases & Changelog</Link>
                        </li>


                        <li className={classes.listItem}>
                            <Link
                                to={{ pathname: process.env.REACT_APP_GET_SUPPORT_PRODUCT_CATALOG_URL }}
                                className="linkText"
                                underline='none'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Support
                            </Link>
                        </li>

                        <li className={classes.listItem}>
                            <Link
                                to={{ pathname: process.env.REACT_APP_FEEDBACK_PRODUCT_CATALOG_URL }}
                                className="linkText"
                                underline='none'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Roadmap</Link>
                        </li>
                    </ul>
                </Grid>
            </SectionBody>
        </Section>
    );

}

export default ProductCatalogue;